import { render, staticRenderFns } from "./figuresIncomeStatementDataMapView.vue?vue&type=template&id=dd153f02&scoped=true"
import script from "./figuresIncomeStatementDataMapView.vue?vue&type=script&lang=js"
export * from "./figuresIncomeStatementDataMapView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd153f02",
  null
  
)

export default component.exports